export default (state, action) => ({
  ...state,
  mountTypes: { ...action.payload },
});
